// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled-card {
  pointer-events: none;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Food/RestaurantsList/RestaurantsList.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".disabled-card {\n  pointer-events: none;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
